/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { BootstrapDialog } from '../../../../assets/style/globalStyle';
import {
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Autocomplete
} from '@mui/material';
import { NotificationManager } from 'react-notifications';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import configAxios from '../../../../services/configAxios';
import Iconify from '../../../../@core/theme/Iconify';

import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';

const AddEditDayTerm = (props) => {
  const [infosClaims, setInfosClaims] = useState([{ codcid: '', cid_description: '' }]);

  useEffect(() => {
    if (props.infosClaims && props.infosClaims.length > 0) {
      setInfosClaims(props.infosClaims);
    }
  }, [props.infosClaims]);

  const [options, setOptions] = useState([]);

  function HandleInputChangeCreate(index, event) {
    const values = [...infosClaims];
    values[index][event.target.name] = event.target.value;
    setInfosClaims(values);
  }

  function HandleSearchCid(term) {
    if (term.length >= 2) {
      configAxios
        .get(`/claims/getCids?term=${term.toUpperCase()}`)
        .then((response) => {
          setOptions(response.data);
        })
        .catch(() => {
          NotificationManager.warning(
            'Tivemos dificuldades para buscar os Cids, por favor, tente novamente!',
            'Atenção'
          );
        });
    }
  }

  function HandleSetCid(event, newValue, index) {
    if (newValue) {
      const values = [...infosClaims];
      values[index].cid_description = newValue.label;
      values[index].cid = newValue.codcid;
      values[index].codcid = newValue.codcid;
      setInfosClaims(values);
    }
  }

  function HandleSubmit(event) {
    event.preventDefault();
    let tableUpdateClaim;
    infosClaims.map((claim) => {
      if (props.rowSelected.tpbenef == 'Titular') {
        claim.tpbenef = 1;
        claim.id_client = props.rowSelected.id;
        claim.id_dep = null;
        if (props.infosClients.tpcontrat !== '2-COLETIVO EMPRESARIAL') {
          tableUpdateClaim = 'tb_declaration_health_clients_resp';
        } else {
          tableUpdateClaim = 'tb_declaration_health_clients_dep_resp';
          claim.id_client = props.infosClients.id;
          claim.id_dep = props.rowSelected.id;
        }
      } else {
        claim.tpbenef = 2;
        claim.id_client = props.infosClients.id;
        claim.id_dep = props.rowSelected.id;
        tableUpdateClaim = 'tb_declaration_health_clients_dep_resp';
      }
      claim.id = null;
    });
    const infosPost = {
      infosClients: props.infosClients,
      infosClaims: infosClaims,
      tableUpdateClaim: tableUpdateClaim
    };
    configAxios
      .post('/claims/addClaim', infosPost)
      .then(() => {
        NotificationManager.success('Agravos realizados com sucesso!', 'Sucesso');
        props.setOpenModal(false);
        setInfosClaims([{ codcid: '', cid_description: '' }]);
        props.functionGrid();
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para realizar os agravos, por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  const handleAddFields = () => {
    setInfosClaims([...infosClaims, { codcid: '', cid_description: '' }]);
  };

  const handleRemoveFields = (index) => {
    const values = [...infosClaims];
    if (index !== 0) {
      values.splice(index, 1);
    }
    setInfosClaims(values);
  };
  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 10,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };
  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired
  };
  return (
    <>
      <div>
        <BootstrapDialog
          onClose={() => {
            props.setOpenModal(false);
            props.functionGrid();
          }}
          aria-labelledby="customized-dialog-title"
          fullWidth
          maxWidth={'md'}
          open={props.openModal}>
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={() => {
              props.setOpenModal(false);
              setInfosClaims([{ codcid: '', descricao_cid: '' }]);
              props.functionGrid();
            }}>
            {infosClaims[0].id
              ? 'Atualizar cadastro de agravos para o beneficiário(a)'
              : 'Cadastro de agravos para o beneficiário(a)'}
          </BootstrapDialogTitle>
          <form onSubmit={HandleSubmit}>
            <DialogContent dividers>
              <CustomInfosForm sx={{ fontSize: '12px' }}>
                Campos obrigatórios possuem asterisco (*)
              </CustomInfosForm>
              <CustomGrid>
                {infosClaims.map((inputField, index) => (
                  <div key={index}>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      <Grid item xs={12} md={5}>
                        <Autocomplete
                          options={options}
                          size="small"
                          getOptionLabel={(option) => option.codcid}
                          value={Object.keys(inputField).length > 0 ? inputField : ''}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="CID (Classificação Internacional de Doenças)"
                              InputLabelProps={{ shrink: true }}
                            />
                          )}
                          onChange={(event, newValue) => HandleSetCid(event, newValue, index)}
                          onInputChange={(event, newInputValue) => HandleSearchCid(newInputValue)}
                          noOptionsText="Digite para buscar..."
                        />
                      </Grid>
                      <Grid item xs={12} md={5}>
                        <TextField
                          name="cid_description"
                          fullWidth
                          label="Descrição do CID (Classificação Internacional de Doenças)"
                          variant="outlined"
                          size="small"
                          type="text"
                          required
                          value={inputField.cid_description || ''}
                          onChange={(event) => HandleInputChangeCreate(index, event)}
                          inputProps={{ maxLength: 255, readOnly: true }}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={2} sx={{ ml: 0 }}>
                        <IconButton onClick={() => handleRemoveFields(index)}>
                          <RemoveIcon />
                        </IconButton>
                        <IconButton onClick={() => handleAddFields()} sx={{ ml: 1 }}>
                          <AddIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </div>
                ))}
              </CustomGrid>
            </DialogContent>
            <DialogActions>
              <Button
                type="submit"
                variant="contained"
                size="medium"
                color="success"
                startIcon={<Iconify icon="eva:save-fill" />}>
                {infosClaims[0].id ? 'Atualizar' : 'Salvar'}
              </Button>
              <Button
                onClick={() => {
                  props.setOpenModal(false);
                  setInfosClaims([{ codcid: '', cid_description: '' }]);
                  props.functionGrid();
                }}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="eva:close-circle-fill" />}>
                Cancelar
              </Button>
            </DialogActions>
          </form>
        </BootstrapDialog>
      </div>
    </>
  );
};

export default AddEditDayTerm;
